import { render, staticRenderFns } from "./HorizontalLicenseLogin.vue?vue&type=template&id=856a8b72&scoped=true"
import script from "./HorizontalLicenseLogin.vue?vue&type=script&lang=js"
export * from "./HorizontalLicenseLogin.vue?vue&type=script&lang=js"
import style0 from "./HorizontalLicenseLogin.vue?vue&type=style&index=0&id=856a8b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856a8b72",
  null
  
)

export default component.exports